import DuctedSlotActions from 'components/systems/ducted-slot-actions';
import useDuctedComponentSwap, {
  DuctedComponentSwapHandler
} from 'hooks/use-ducted-component-swap';
import useDuctedSectionSwapCandidates from 'hooks/use-ducted-section-swap-candidates';
import { useMemo } from 'react';
import { combinationSlotValues } from 'utils/ducted-component-swap';
import DuctedSlotProductRow from './ducted-slot-product-row';
import { DuctedSlotRow } from './ducted-slot-rows';

type DuctedSwappableSlotRowsProps = Readonly<{
  rows: DuctedSlotRow[];
  combination: Record<string, unknown>;
  systemUniqueId: string;
  onComponentSwap: DuctedComponentSwapHandler;
}>;

export default function DuctedSwappableSlotRows({
  rows,
  combination,
  systemUniqueId,
  onComponentSwap
}: DuctedSwappableSlotRowsProps) {
  const { candidates, isLoading } =
    useDuctedSectionSwapCandidates(systemUniqueId);
  const current = useMemo(
    () => combinationSlotValues(combination),
    [combination]
  );
  const swapModel = useDuctedComponentSwap(
    current,
    candidates,
    onComponentSwap
  );

  return (
    <>
      {rows.map((row) => (
        <DuctedSlotProductRow
          key={row.slot}
          row={row}
          actions={
            <DuctedSlotActions
              slot={row.slot}
              currentPrice={row.product?.price ?? 0}
              swapModel={swapModel}
              isLoading={isLoading}
            />
          }
        />
      ))}
    </>
  );
}
